/* Enter your Custom Javascript code below without script tag */

 /* Company name: Developed by TechFanatic 
 Website URL: https://techfanatic.in/ */

document.addEventListener('DOMContentLoaded', function () {
    console.log("DOM fully loaded and parsed");

    // Select all image elements in the slider
    var images = document.querySelectorAll('.swiper-slide img.slide-img');
    console.log("Found", images.length, "images");

    if (images.length === 0) {
        console.warn("No images found with class 'slide-img'. Check if the class or DOM structure has changed.");
    }

    // URLs to link the images
    var urls = [
        'https://yochaakhosa.com/collections/frontpage', //3rd banner
        'https://yochaakhosa.com/collections/winter-treats/products/winter-special-pitara', //2nd banner
        'https://yochaakhosa.com/collections/winter-treats'  //1st banner
    ];


    images.forEach(function (image, index) {
        
        if (image.closest('a')) {
            console.log("Image already wrapped in a link:", image.src);
            return; // Skip if already clickable
        }

        // Create an anchor element
        var link = document.createElement('a');

        // Set the URL for the link
        link.href = urls[index % urls.length];
        console.log("Setting link for image", index, "to", link.href);

        // Insert the link before the image and move the image inside the link
        image.parentNode.insertBefore(link, image);
        link.appendChild(image);

        console.log("Image", index, "wrapped in link:", image.src);
    });

    console.log("Image link wrapping complete.");
});
/* corporate gift page */
document.addEventListener("DOMContentLoaded", function () {
  // Grab both sections
  const section1 = document.getElementById("shopify-section-template--18632643903656__home_product_carousel_TPaCLi");
  const section2 = document.getElementById("shopify-section-template--18632643903656__1728398898d299c48d");

  if (section1 && section2) {
    // Get the parent container
    const parent = section1.parentNode;

    // Make parent flexbox
    parent.style.display = "flex";
    parent.style.gap = "20px"; // space between
    parent.style.alignItems = "flex-start";
    parent.style.flexWrap = "wrap";

    // Apply widths
    section1.style.flex = "0 0 68%";
    section1.style.maxWidth = "68%";

    section2.style.flex = "0 0 30%";
    section2.style.maxWidth = "30%";
  }
});


function adjustLayout() {
  const section1 = document.getElementById("shopify-section-template--18632643903656__home_product_carousel_TPaCLi");
  const section2 = document.getElementById("shopify-section-template--18632643903656__1728398898d299c48d");

  if (window.innerWidth <= 768) {
    section1.style.flex = "0 0 100%";
    section1.style.maxWidth = "100%";
    section2.style.flex = "0 0 100%";
    section2.style.maxWidth = "100%";
  } else {
    section1.style.flex = "0 0 68%";
    section1.style.maxWidth = "68%";
    section2.style.flex = "0 0 30%";
    section2.style.maxWidth = "30%";
  }
}

document.addEventListener("DOMContentLoaded", adjustLayout);
window.addEventListener("resize", adjustLayout);